// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCC_1YxtoTMJcgBpJSxfrZICypWQy0CucI",
  authDomain: "perceptron-xfms.firebaseapp.com",
  projectId: "perceptron-xfms",
  storageBucket: "perceptron-xfms.appspot.com",
  messagingSenderId: "956090883975",
  appId: "1:956090883975:web:d1f1e9460e66d43712bd22"

  }
};


// apiKey: "AIzaSyCqHOjPtqY7MxWRtj-RDW7aI-n8fe1ldmM",
//     authDomain: "perceptron-51a86.firebaseapp.com",
//     databaseURL: "https://perceptron-51a86.firebaseio.com",
//     projectId: "perceptron-51a86",
//     storageBucket: "perceptron-51a86.appspot.com",
//     messagingSenderId: "708562387352",
//     appId: "1:708562387352:web:f685ab2e4474c6c941abed",
//     measurementId: "G-318PE2YSNP"





//New Firebase 
// apiKey: "AIzaSyCqHOjPtqY7MxWRtj-RDW7aI-n8fe1ldmM",
//     authDomain: "perceptron-51a86.firebaseapp.com",
//     databaseURL: "https://perceptron-51a86.firebaseio.com",
//     projectId: "perceptron-51a86",
//     storageBucket: "perceptron-51a86.appspot.com",
//     messagingSenderId: "708562387352",
//     appId: "1:708562387352:web:f685ab2e4474c6c941abed",
//     measurementId: "G-318PE2YSNP"


// Old Firebase
// apiKey: "AIzaSyCrdVbt7BrEne5lok4F78wjWxDtLNDcQs4",
// authDomain: "proteomics-tdp.firebaseapp.com",
// databaseURL: "https://proteomics-tdp.firebaseio.com",
// projectId: "proteomics-tdp",
// storageBucket: "proteomics-tdp.appspot.com",
// messagingSenderId: "589100138546"



// WEBPACK FOOTER //
// ./src/environments/environment.ts